// extracted by mini-css-extract-plugin
export var text = "_az-0";